export const GUEST_DOCUMENT_SIGNATURE_EVENT_KEYS = {
	eventTypes: (locationId: number) => [
		"guest-document-signature-event-types",
		locationId,
	],
};
